// eslint-disable-next-line no-unused-vars
import React, { useState, useContext } from "react";
import { useNavigationEvent } from "navigation-react";
import loginImage from "./images/loginImage.jpg";
import anihlogoimage from "./images/idcnewlogo.png";
import SecureLS from "secure-ls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { RoleContext } from "./App";

const ls = new SecureLS({ encodingType: "aes" });

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { setActiveRole, setPermissions } = useContext(RoleContext);
  const { stateNavigator } = useNavigationEvent();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      alert("Please enter both username and password");
      return;
    }

    setLoading(true);

    try {
      // Login API
      const res = await fetch(`${process.env.REACT_APP_LOGIN_URL}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ name: username, pass: password }),
      });

      if (!res.ok) {
        let err;
        try {
          err = await res.json();
        } catch {
          err = {};
        }
        const errMsg = err?.message ?? "Unknown error";
        alert(`Login failed: ${errMsg}`);
        console.log(`HTTP error: ${res.status}`);
        return;
      }

      const data = await res.json();

      // Store minimal user info (no password)
      ls.set("username", data.current_user.name);
      ls.set("userlogout_token", data.logout_token);
      ls.set("currentuserid", data.current_user.uid);

      // Fetch permissions after login
      const tokenRes = await fetch(
        `${process.env.REACT_APP_SESSION_TOKEN_URL}`,
        {
          method: "GET",
          credentials: "include",
          headers: { Accept: "application/json" },
        }
      );

      if (!tokenRes.ok) {
        console.log("tokenRes", tokenRes.statusText);
      }
      const csrfToken = await tokenRes.text(); // memory only

      const permRes = await fetch(
        `${process.env.REACT_APP_GET_PERMISSIONS_API}`,
        {
          method: "GET",
          credentials: "include",
          headers: { Accept: "application/json", "X-CSRF-Token": csrfToken },
        }
      );

      if (!permRes.ok) {
        console.log("Permissions load failed", permRes.statusText);
      }
      const permData = await permRes.json();

      // Determine active role
      const rolesObj = permData.user?.roles || {};
      let active = "";
      if (rolesObj.administrator) active = "administrator";
      else if (rolesObj.radiologist) active = "radiologist";
      else if (rolesObj.requester) active = "requester";
      else if (rolesObj.assigner) active = "assigner";

      setActiveRole(active);
      setPermissions(rolesObj[active]?.permissions || []);

      // Store minimal info in SecureLS for UI convenience
      ls.set("activeRole", active);
      ls.set("permissions", rolesObj[active]?.permissions || []);
      ls.set(
        "currentuserfullname",
        [
          permData.user.fields.field_first_name,
          permData.user.fields.field_last_name,
        ]
          .filter(Boolean)
          .join(" ")
      );

      stateNavigator.navigate("dashboardcontent");
    } catch (err) {
      console.error("Login Error:", err);
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-left">
        <div className="login-overlay">
          <div className="login-brand">
            <img src={anihlogoimage} alt="IDC Logo" className="login-logo" />
            <h1>Diagnostic Portal</h1>
          </div>
          <p className="login-tagline">
            Welcome back! Please sign in to continue.
          </p>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <label htmlFor="username">Username</label>
            </div>

            <div className="input-group">
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <label htmlFor="password">Password</label>
            </div>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? (
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                  strokeWidth={20}
                  fontSize={22}
                />
              ) : (
                "Login"
              )}
            </button>
          </form>
        </div>
      </div>

      <div className="login-right">
        <img src={loginImage} alt="Login visual" className="login-image" />
      </div>
    </div>
  );
};

export default Login;
